/* Father's Day Landing — countdown + sticky CTA. Dependency-free, ~1KB. */
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function initCountdown(el) {
    if (el.dataset.fdlInit) { return; }
    el.dataset.fdlInit = '1';
    /* Prefer the epoch from the playoff_sale metaobject (timezone-proof);
       fall back to the legacy ISO string setting. */
    var ts = parseInt(el.getAttribute('data-deadline-ts'), 10);
    var target = ts > 0 ? ts * 1000 : new Date(el.getAttribute('data-deadline')).getTime();
    if (isNaN(target)) { return; }

    var section = el.closest('.fdl-deadline');

    /* Re-render the label's [date] in store time so every shopper sees the
       intended order-by day regardless of how Liquid serialized the UTC value. */
    var dateSpan = section ? section.querySelector('[data-fdl-deadline-date]') : null;
    if (dateSpan) {
      try {
        dateSpan.textContent = new Intl.DateTimeFormat('en-CA', {
          weekday: 'long', month: 'long', day: 'numeric', timeZone: 'America/Toronto'
        }).format(new Date(target));
      } catch (e) { /* keep the server-rendered date */ }
    }
    var dEl = el.querySelector('[data-days]');
    var hEl = el.querySelector('[data-hours]');
    var mEl = el.querySelector('[data-mins]');
    var sEl = el.querySelector('[data-secs]');
    var timer = null;

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        if (section) {
          section.classList.add('is-done');
          var label = section.querySelector('.fdl-deadline__label');
          var done = el.getAttribute('data-done-text');
          if (label && done) { label.textContent = done; }
        }
        if (timer) { clearInterval(timer); timer = null; }
        return;
      }
      if (dEl) dEl.textContent = pad(Math.floor(diff / 86400000));
      if (hEl) hEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      if (mEl) mEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (sEl) sEl.textContent = pad(Math.floor((diff % 60000) / 1000));
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  function initSticky(el) {
    if (el.dataset.fdlInit) { return; }
    el.dataset.fdlInit = '1';
    var ticking = false;
    function update() {
      el.classList.toggle('is-visible', window.scrollY > 420);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initReveal() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) { return; }
    var roots = document.querySelectorAll('.fdl');
    for (var r = 0; r < roots.length; r++) { roots[r].classList.add('is-reveal'); }
    var els = document.querySelectorAll('.fdl-reveal:not([data-fdl-rev])');
    if (!els.length) { return; }
    var io = new IntersectionObserver(function (entries) {
      for (var k = 0; k < entries.length; k++) {
        if (entries[k].isIntersecting) { entries[k].target.classList.add('is-in'); io.unobserve(entries[k].target); }
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    for (var i = 0; i < els.length; i++) { els[i].setAttribute('data-fdl-rev', '1'); io.observe(els[i]); }
  }

  function initSliderNav() {
    var btns = document.querySelectorAll('[data-fdl-prev], [data-fdl-next]');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].dataset.fdlNavInit) { continue; }
      btns[i].dataset.fdlNavInit = '1';
      btns[i].addEventListener('click', function (e) {
        var band = e.currentTarget.closest('.fdl-band');
        var slider = band ? band.querySelector('[data-fdl-slider]') : null;
        if (!slider) { return; }
        var dir = e.currentTarget.hasAttribute('data-fdl-next') ? 1 : -1;
        slider.scrollBy({ left: dir * Math.max(260, slider.clientWidth * 0.8), behavior: 'smooth' });
      });
    }
  }

  function boot(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var cd = root.querySelectorAll('[data-fdl-countdown]');
    for (var i = 0; i < cd.length; i++) { initCountdown(cd[i]); }
    var sticky = root.querySelectorAll('[data-fdl-sticky]');
    for (var j = 0; j < sticky.length; j++) { initSticky(sticky[j]); }
    initReveal();
    initSliderNav();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Theme Editor: re-init when this section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
